import asyncSeries from 'async/series';

export default {
  isAvailable,
  getAddress,
  getChainId,
  connect,
  ethSign,
  ethSend,
};

let g_address;
function isAvailable(): boolean {
  return Boolean(window && window.ethereum && window.ethereum.request);
}
function getAddress(): string | undefined {
  return g_address;
}
function getChainId(done): number {
  const opts = {
    method: 'eth_chainId',
  };
  _request(opts, (err, result) => {
    let chain_id = 0;
    if (result) {
      chain_id = parseInt(result);
    }
    done(err, chain_id);
  });
}
function connect(params, done) {
  const { chainId } = params;
  asyncSeries(
    [
      (done) => {
        const opts = {
          method: 'eth_accounts',
        };
        _request(opts, (err, result) => {
          if (!err && result && result.length > 0) {
            g_address = result[0];
          }
          done();
        });
      },
      (done) => {
        if (g_address) {
          done();
        } else {
          const opts = {
            method: 'eth_requestAccounts',
          };
          _request(opts, (err, result) => {
            if (!err && result && result.length > 0) {
              g_address = result[0];
            }
            done(err);
          });
        }
      },
      (done) => {
        if (chainId !== undefined) {
          _switchChain(params, done);
        } else {
          done();
        }
      },
    ],
    done
  );
}
function ethSign(params, done) {
  const { from, message } = params;
  const opts = {
    method: 'eth_sign',
    params: [from, message],
  };
  _request(opts, done);
}
function ethSend(tx, done) {
  const opts = {
    method: 'eth_sendTransaction',
    params: [tx],
    chainId: tx.chainId,
  };
  _request(opts, done);
}
function _request(opts, done) {
  const { chainId, ...other } = opts;

  let result;
  asyncSeries(
    [
      (done) => {
        if (isAvailable()) {
          done();
        } else {
          done('not_available');
        }
      },
      (done) => {
        if (chainId) {
          _switchChain({ chainId }, done);
        } else {
          done();
        }
      },
      (done) => {
        window.ethereum.request(other).then(
          (data) => {
            result = data;
            done(null);
          },
          (err) => {
            const code = err && err.code;
            if (code === 4001) {
              err = 'user_cancel';
            }
            done(err);
          }
        );
      },
    ],
    (err) => done(err, result)
  );
}
function _switchChain(params, done) {
  const { chainId, chainInfo } = params;

  let old_chain_id;
  asyncSeries(
    [
      (done) => {
        getChainId((err, id) => {
          if (!err) {
            old_chain_id = id;
          }
          done();
        });
      },
      (done) => {
        if (old_chain_id === chainId) {
          done();
        } else {
          const opts = {
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: '0x' + _hex(chainId) }],
          };
          window.ethereum.request(opts).then(
            (result) => {
              done(null, result);
            },
            (err) => {
              const code = err && err.code;
              if (code === 4902 && chainInfo) {
                _addChain(chainInfo, done);
              } else {
                if (code === 4001) {
                  err = 'user_cancel';
                }
                done(err);
              }
            }
          );
        }
      },
    ],
    done
  );
}
function _addChain(chainInfo, done) {
  const opts = {
    method: 'wallet_addEthereumChain',
    params: [chainInfo],
  };
  window.ethereum.request(opts).then(
    (result) => {
      done(null, result);
    },
    (err) => {
      const code = err && err.code;
      if (code === 4001) {
        err = 'user_cancel';
      }
      done(err);
    }
  );
}
function _hex(s) {
  return parseInt(String(s)).toString(16);
}
